/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { modalApi } from './modals';
import { closeDelayedSignal } from '../api';
import { ApiDataResponse } from '../api/types/response';
import { DelayedSignal } from '../types/delayedSignal';
import { Nullable } from '../utils/types';

type TDelayedSignals$State = {
  totalPage: number;
  signals: DelayedSignal[];
};

const initialState: TDelayedSignals$State = {
  totalPage: 0,
  signals: [],
};

export const DelayedSignals$ = createStore<TDelayedSignals$State>(initialState);

const { add, close } = createApi(DelayedSignals$, {
  // @ts-ignore
  add: (state, signal) => {
    return {
      ...state,
      signals: [...state.signals, signal],
    };
  },
  // @ts-ignore
  close: (state, { result, params }) => {
    const updatedState = { ...state };

    if (result.success) {
      updatedState.signals = updatedState.signals.filter((item) => item.id !== params.id);
    }

    return updatedState;
  },
});

export const delayedSignalsApi = {
  close: createEffect<Nullable<string>, ApiDataResponse<unknown>, {}>().use(closeDelayedSignal),
  add: createEffect(),
};

sample({
  clock: delayedSignalsApi.close.done,
  target: close,
});

sample({
  clock: delayedSignalsApi.add,
  target: add,
});

sample({
  clock: delayedSignalsApi.close.done,
  filter: ({ result }) => result.success,
  fn: () => '',
  target: modalApi.hide,
});
